import React from 'react';
import { buildClassName } from '../../../utils';
import styles from '../DesktopNavigation.module.scss';

interface NavigationDividerProps {
  className?: string;
}

export const NavigationDivider = ({ className }: NavigationDividerProps) => (
  <div className={buildClassName(styles.divider, className)} />
); 